export const UPDATE_AUTH = (state, auth) => {
  state.auth = auth;
};

export const UPDATE_USER = (state, user) => {
  state.user = user;
};

export const UPDATE_ERROR = (state, msg) => {
  state.error = msg;
};
export const PERFORMING_LOGIN = (state, islogging) => {
  state.auth.isLogging = islogging;
};

export const UPDATE_LOGIN_ERROR = (state, error) => {
  if (error && error !== '') {
    state.auth.loginError = true;
    state.auth.loginErrorMsg = error;
  } else {
    state.auth.loginError = false;
    state.auth.loginErrorMsg = null;
  }
};

export const CHANGE_OVERLAY = (state) => {
  state.overlay = !state.overlay;
};

export const CHANGE_SCROLLY = (state, payload) => {
  state.layout.scrollY = payload;
};
export const CHANGE_WINDOW_HEIGHT = (state, payload) => {
  state.layout.windowHeight = payload;
};
export const CHANGE_WINDOW_WIDTH = (state, payload) => {
  state.layout.windowWidth = payload;
};
export const CHANGE_WINDOW_DEVICE = (state, payload) => {
  state.layout.device = payload;
};
/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out
 * state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
export const CLEAR_ALL_DATA = (state) => {
  // Auth
  state.auth.isLoggedIn = false;
  state.auth.isLogging = false;
  state.auth.loginError = null;
  state.auth.accessToken = null;
  state.auth.refreshToken = null;

  // User
  // state.user.name = ''
  state.user = null;

  // Dashboard
  if (state.dashboard) {
    state.dashboard.operaciones = [];
    state.dashboard.borradores = [];
    state.dashboard.enCurso = [];
    state.dashboard.enEstudio = [];
    state.dashboard.firmadas = [];
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js